import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  // Switch,
  // Route,
  NavLink
} from "react-router-dom";
import scrollToComponent from 'react-scroll-to-component';

import logo from "../img/logo.png";
import '../App.css';

import Home from './Home';
import About from './About';
import Updates from './Updates';
import Career from './Career';

class Header extends Component {

  componentDidMount() {
    scrollToComponent(this.Home, { offset: 0, align: 'middle', duration: 500, ease:'inCirc'});
  }

  render() {
    return (
      <>
        <Router>
        <div className="ui container head">
            <NavLink className="item" activeclassname = "active" activeonlywhenexact="true" exact to="/">
            <img src={logo} className="logo" alt="logo" />
            </NavLink>
          <div className="ui secondary pointing menu">
            <NavLink className="item" activeclassname = "active" activeonlywhenexact="true" exact to="/"
            onClick={() => scrollToComponent(this.Home, { offset: 0, align: 'top', duration: 1500})}
            >Home</NavLink>
            <NavLink className="item" activeclassname = "active" activeonlywhenexact="true" exact to="/about"
            onClick={() => scrollToComponent(this.About, { offset: 0, align: 'top', duration: 1500})}
            >About</NavLink>
            <NavLink className="item" activeclassname = "active" activeonlywhenexact="true" exact to="/updates"
            onClick={() => scrollToComponent(this.Updates, { offset: 0, align: 'top', duration: 1500})}
            >Updates</NavLink>
            <NavLink className="item" activeclassname = "active" activeonlywhenexact="true" exact to="/career"
            onClick={() => scrollToComponent(this.Career, { offset: 0, align: 'bottom', duration: 1500})}
            >Career</NavLink>
          </div>

          <div className="ui inverted segment">
            <div className="ui inverted transparent icon input">
              <input type="text" placeholder="Search..." />
              <i className="search icon" />
            </div>
          </div>

        </div>
          {/* <Switch>
           <Route exact path="/" component={Home} />
           <Route path="/about" component={About} />
           <Route path="/updates" component={Updates} />
            <Route path="/career" component={Career} />
          </Switch> */}
      </Router>
          <section ref={(section) => { this.Home = section; }}><Home /></section>
          <section ref={(section) => { this.About = section; }}><About /></section>
          <section ref={(section) => { this.Updates = section; }}><Updates /></section>
          <section ref={(section) => { this.Career = section; }}><Career /></section>
      </>
    )
  }
}

export default Header;
